<template>
    <va-create-layout>
        <AdsConfiguration-form
            :title="title"
            :item="item"
        ></AdsConfiguration-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
